module.exports = [{
      plugin: require('/Users/devinleggett/Documents/Projects/weather-app/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
